var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.998,
    height: 17.29,
    fill: "currentColor",
    stroke: "currentColor",
    viewBox: "0 0 17.998 17.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_121",
    "data-name": "Gruppe 121",
    transform: "translate(-279.96 -1680)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit",
    d: "M0,13.688v3.6H3.6L14.224,6.668l-3.6-3.6ZM17.009,3.883a.956.956,0,0,0,0-1.354L14.762.281a.956.956,0,0,0-1.354,0L11.65,2.038l3.6,3.6Z",
    "data-name": "Icon material-edit",
    transform: "translate(279.96 1680)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_118",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M318.387,1684.6v6.895",
    "data-name": "Pfad 118",
    transform: "translate(-23.876 5.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_119",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M0,0V6.895",
    "data-name": "Pfad 119",
    transform: "translate(297.958 1693.817) rotate(90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilAdd);
export default __webpack_public_path__ + "static/media/pencil_add.fe1b560b247bcbc0db634e8f942e5f04.svg";
export { ForwardRef as ReactComponent };